import { stepsWithoutDataSources } from '../legislativeTour';

export const CALCULATOR_TOUR_STORAGE_KEY = 'cityExplorer:opportunityCalculatorTour:v1';
export const CALCULATOR_DATA_SOURCES_STEP_INDEX = 4;

const DATA_SOURCES_STEP = {
  id: 'data-sources',
  title: 'Data sources',
  body: 'The metric files behind this model are in the left panel under Data Sets. Change weights here, then Export CSV — the downloads do not recalculate.',
  cardAlign: 'bottom-left',
};

const BASE_STEPS = [
  {
    id: 'level',
    title: 'Districts or regions',
    body: 'Rank school districts or planning regions. Switching level restores the workbook weights and breakpoints for that geography.',
    spotlight: 'level',
    cardAlign: 'top-right',
  },
  {
    id: 'insights',
    title: 'What the ranking is saying',
    body: 'These cards tell you which indicator is separating the field and where data is still missing. A gap that every district shares does not change rank order; a gap that only some districts have does.',
    spotlight: 'insights',
    cardAlign: 'top-right',
  },
  {
    id: 'scoring',
    title: 'Scoring model',
    body: 'Open Scoring model to change weights, the enrollment floor, how missing values are scored, and the 1–5 breakpoints. Presets restore the workbook mix or equal weights. Share calculator creates a public or password-protected link, the same way maps are shared. On a shared page, copy the URL to keep your mix.',
    spotlight: 'scoring',
    cardAlign: 'bottom-right',
    expandScoring: true,
  },
  {
    id: 'table',
    title: 'The ranking',
    body: 'Each row is a scored district or region on a 100-point scale. The table shows the key metrics behind the score; Show all metrics keeps those and adds the rest of the scoring indicators. Search, sort, export CSV with values and scores, or click a row for the contribution breakdown.',
    spotlight: 'table',
    cardAlign: 'top-right',
  },
];

export const calculatorTourSteps = ({ includeDataSources = true, includeLevel = true } = {}) => {
  const steps = includeLevel ? [...BASE_STEPS] : BASE_STEPS.filter((step) => step.id !== 'level');
  if (includeDataSources) steps.push(DATA_SOURCES_STEP);
  return steps;
};

export const calculatorTourStepsWithoutDataSources = () =>
  stepsWithoutDataSources(calculatorTourSteps({ includeDataSources: true }));

const readFlag = (key) => {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch (_err) {
    return false;
  }
};

const writeFlag = (key) => {
  try {
    window.localStorage.setItem(key, '1');
  } catch (_err) {
    // Private browsing or disabled storage should not break the calculator.
  }
};

export const readCalculatorTourDismissed = () => readFlag(CALCULATOR_TOUR_STORAGE_KEY);
export const writeCalculatorTourDismissed = () => writeFlag(CALCULATOR_TOUR_STORAGE_KEY);

export const shouldShowCalculatorTour = ({ dismissed, replaying, isFullscreen }) =>
  Boolean(!isFullscreen && (!dismissed || replaying));
